import dayjs from 'dayjs'

export const stringDateWithoutTime = (date: string) => date ? dayjs(date).format('DD.MM.YYYY') : null
export const stringDateWithTime = (date: string) => date ? dayjs(date).format('DD.MM.YYYY HH:mm:ss') : null

